var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.874,
    height: 23.916,
    viewBox: "0 0 23.874 23.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-call",
    "data-name": "Icon feather-phone-call",
    d: "M16.651,5.668a5.211,5.211,0,0,1,4.116,4.116M16.651,1.5a9.379,9.379,0,0,1,8.285,8.274M23.893,18.09v3.126A2.084,2.084,0,0,1,21.622,23.3a20.623,20.623,0,0,1-8.993-3.2,20.321,20.321,0,0,1-6.253-6.253,20.623,20.623,0,0,1-3.2-9.035A2.084,2.084,0,0,1,5.25,2.542H8.376a2.084,2.084,0,0,1,2.084,1.792,13.381,13.381,0,0,0,.729,2.928,2.084,2.084,0,0,1-.469,2.2L9.4,10.785a16.674,16.674,0,0,0,6.253,6.253l1.323-1.323a2.084,2.084,0,0,1,2.2-.469,13.381,13.381,0,0,0,2.928.729A2.084,2.084,0,0,1,23.893,18.09Z",
    transform: "translate(-2.167 -0.396)",
    fill: "none",
    stroke: "#fdb713",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contact-phone.9d2ba86c39d492cafe31d7df837baba7.svg";
export { ForwardRef as ReactComponent };